import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DeleteTextButton from '../atoms/DeleteTextButton';
import EditTextButton from '../atoms/EditTextButton';
// import ShowHideTextButton from '../atoms/ShowHideTextButton';
import ShowHideSwitchButton from '../atoms/ShowHideSwitchButton';
import ChangeEventPriorityTextButton from '../atoms/ChangeEventPriorityTextButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      gochiEventName: PropTypes.string,
      gochiEventId: PropTypes.number,
      startDate: PropTypes.string,
      endDate: PropTypes.number,
      eventFeeRate: PropTypes.string,
      supportPricePercentRate: PropTypes.string,
      maxTotalAmount: PropTypes.string,
      maxTotalAmountPerOrder: PropTypes.string,
      maxTotalAmountShop: PropTypes.string,
      shopFeeRate: PropTypes.string,
      gochiExpriedDate: PropTypes.string,
      gochiStartDate: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    events,
    editOpenAction,
    deleteOpenAction,
    order,
    orderBy,
    showHideOpenAction
  }) => {
    const sortedResult = _.orderBy(events, orderBy, order);
    // const listMenuTypeHideEdit = ['DEFAULT'];
    return (
      <TableBody>
        {sortedResult.map(gochiEvent => {
          const key = `${gochiEvent.gochiEventId}`;
          return (
            <TableRow key={key} hover>
              <TableCell>
                <EditTextButton
                  id={gochiEvent.gochiEventId}
                  onClickAction={editOpenAction}
                />
              </TableCell>
              <TableCell>{gochiEvent.gochiEventId}</TableCell>
              <TableCell>
                <ChangeEventPriorityTextButton
                  key={gochiEvent.gochiEventId}
                  eventId={gochiEvent.gochiEventId}
                  eventPriority={gochiEvent.eventOrder}
                />
              </TableCell>
              <TableCell>{gochiEvent.gochiEventName}</TableCell>
              <TableCell>
                {gochiEvent.eventCategory === 2
                  ? 'イベントメニューの対象'
                  : '全グループの対象'}
              </TableCell>
              <TableCell>
                {gochiEvent.eventCategory === 1
                  ? gochiEvent.group && gochiEvent.group.groupName
                  : ''}
              </TableCell>
              <TableCell>
                {gochiEvent.startDate &&
                  moment(gochiEvent.startDate).format('YYYY-MM-DD HH:mm:ss')}
              </TableCell>
              <TableCell>
                {gochiEvent.endDate &&
                  moment(gochiEvent.endDate).format('YYYY-MM-DD HH:mm:ss')}
              </TableCell>
              <TableCell>{gochiEvent.eventFeeRate}</TableCell>
              <TableCell>{gochiEvent.supportPricePercentRate}</TableCell>
              <TableCell>{gochiEvent.maxTotalAmount}</TableCell>
              <TableCell>{gochiEvent.maxTotalAmountPerOrder}</TableCell>
              <TableCell>{gochiEvent.maxTotalAmountShop}</TableCell>
              <TableCell>{gochiEvent.shopFeeRate}</TableCell>
              <TableCell>
                {gochiEvent.gochiStartDate &&
                  moment(gochiEvent.gochiStartDate).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
              </TableCell>
              <TableCell>
                {gochiEvent.gochiExpriedDate &&
                  moment(gochiEvent.gochiExpriedDate).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
              </TableCell>
              <TableCell>
                {gochiEvent.createdAt &&
                  moment(gochiEvent.createdAt).format('YYYY-MM-DD HH:mm')}
              </TableCell>
              <TableCell>
                {gochiEvent.updatedAt &&
                  moment(gochiEvent.updatedAt).format('YYYY-MM-DD HH:mm')}
              </TableCell>
              <TableCell>
                <ShowHideSwitchButton
                  params={gochiEvent}
                  onClickAction={showHideOpenAction}
                  showHide={gochiEvent.status ? 1 : 0}
                  // disabled
                />
              </TableCell>
              <TableCell>
                <DeleteTextButton
                  id={gochiEvent.gochiEventId}
                  onClickAction={deleteOpenAction}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
